import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { DesignIcon, PencilIcon } from 'assets/icons'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import PageActions from 'src/components/PageActions'

const CustomPageActions = () => {
   const match = useRouteMatch()

   return (
      <PageActions
         editMenuOptions={
            <>
               <Link to={`${match.url}/edit`}>
                  <ListMenuButton
                     name="Open in Visual Editor"
                     description="Edit the content, design, and layout for this page"
                     icon={(
                        <DesignIcon
                           width="16px"
                           height="16px"
                           color="#aaa"
                        />
                     )}
                  />
               </Link>
               <Link to={`${match.url}/settings`}>
                  <ListMenuButton
                     name="Page Info & Settings"
                     description="Edit the settings for this page"
                     icon={(
                        <PencilIcon
                           width="16px"
                           height="16px"
                           color="#aaa"
                        />
                     )}
                  />
               </Link>
            </>
         }
      />
   )
}

export default CustomPageActions
